const tracksDE = {
    "view": {
        "table": {
            "title": "Tracks bearbeiten",
            "column": {
                "name": "Name",
                "mixName": "Mix-Name",
                "mixLength": "Mix-Länge",
                "player": "Player",
                "status": "Status",
                "accStatus": "Acc-Status",
                "qc": "QC",
                "action": "Aktion"
            },
            "button": {
                "edit": "Bearbeiten",
                "goToReleases": "Zu Veröffentlichungen gehen",
                "distribute": "Verteilen",
                "submitEditing": "Bearbeitung einreichen",
                "statusReady": "Bereit",
                "statusNotReady": "Nicht bereit"
            },
            "message": {
                "identityNotCheckedTooltip": "Sie haben Ihre vollständigen Informationen noch nicht bereitgestellt, daher können Sie die Veröffentlichungen nicht verteilen. Um dies zu tun, reichen Sie bitte Ihre Informationen ein.",
                "tracksNotReadyTooltip": "Bitte reichen Sie die Metadaten für alle Tracks ein, um die Veröffentlichung zu verteilen.",
                "tracksNotReadyForEditingTooltip": "Bitte reichen Sie die Metadaten für alle Tracks ein, um die Bearbeitungen einzureichen.",
                "distributionDisabledPreScanInProgressTooltip": "Bitte warten Sie, bis der Pre Scan abgeschlossen ist, bevor Sie die Veröffentlichung verteilen.",
                "distributionDisabledPreScanNotDoneTooltip": "Bitte führen Sie zuerst den Pre Scan aus, um die Veröffentlichung zu verteilen.",
                "distributionDisabledPreScanDeclarationNotSubmittedTooltip": "Bitte reichen Sie zuerst die Pre Scan-Erklärung ein, um die Veröffentlichung zu verteilen.",
                "browserNotSupported": "Ihr Browser unterstützt das Audioelement nicht.",
                "trackUpdated": "Track wurde aktualisiert!"
            },
            "modal": {
                "distribute": {
                    "header": "Sind Sie sicher, dass alle eingegebenen Informationen gültig sind und diese Veröffentlichung vollständig repräsentieren?",
                    "body": {
                        "point1": "Nach dieser Aktion wird Ihre Veröffentlichung überprüft und, wenn die Informationen korrekt sind, an den offiziellen und exklusiven Veröffentlichungsterminen verteilt.",
                        "point2": "Durch Bestätigen und Akzeptieren dieses Formulars akzeptieren und befolgen Sie vollständig die <1>Vertriebsbedingungen</1>, <3>Nutzungsbedingungen</3> und <5>Datenschutzrichtlinie</5>.",
                        "point3": "Durch Bestätigen und Akzeptieren dieses Formulars bestätigen Sie unwiderruflich, dass die eingereichte Veröffentlichung mit zugehörigen Assets, Audiodateien und Metadaten entweder ausschließlich Ihnen gehört oder vollständig an Ihr Label lizenziert ist.",
                        "point4": "Hiermit akzeptieren Sie vollumfänglich, dass Sie allein für irreführende Informationen, unlizenzierte Nutzung, illegale Aktivitäten oder jegliche Art von Streit verantwortlich sind.",
                        "flaggedTracksTerms": {
                            "header": "Bedingungen für markierte Tracks",
                            "point1": "Bitte beachten Sie: <strong>'{{releaseName}}'</strong> enthält einen oder mehrere markierte Tracks. Eine Gebühr von <strong>15 €</strong> pro markiertem Track fällt an, um die Veröffentlichung an <strong>Spotify</strong> zu liefern. Da Sie sich entschieden haben, diese Gebühr derzeit nicht zu zahlen, wird die Veröffentlichung nicht an Spotify geliefert. Durch Bestätigen und Akzeptieren dieses Formulars erkennen Sie diese Bedingungen an und akzeptieren sie.",
                            "point2": "In Zukunft, wenn Sie sich entscheiden, die Veröffentlichung an <strong>Spotify</strong> zu liefern, können Sie zum markierten Abschnitt in der Veröffentlichungstabelle gehen und den Zahlungsaufforderungen folgen."
                        },
                        "artificialStreamingDeclaration": {
                            "header": "Erklärung zu künstlichem Streaming",
                            "point1": "<strong>1.</strong> Ich verstehe und stimme voll und ganz zu, keine Form von künstlichem Streaming zu betreiben, einschließlich der Verwendung von Bots, Streaming-Farmen oder jeglicher Methode, die DSP-Metriken manipuliert.",
                            "point2": "<strong>2.</strong> Ich werde keine Zahlung für Playlist-Platzierungen leisten oder anbieten, noch werde ich mit Dritten zusammenarbeiten, die garantierte Platzierungen versprechen — ich verstehe, dass dies als Betrug und Täuschung gilt.",
                            "point3": "<strong>3.</strong> Ich erkenne an, dass solche Handlungen zur sofortigen Kündigung, zum Verlust von Tantiemen, zu rechtlichen Ansprüchen, Vertragsstrafen und Gebühren sowie zur Meldung an DSPs und Behörden führen können.",
                            "point4": "<strong>4.</strong> Ich garantiere außerdem, alle Künstler oder Kunden, mit denen ich zusammenarbeite, über diese Regeln zu informieren und sicherzustellen, dass sie diese einhalten.",
                            "point5": "<strong>5.</strong> Ich verstehe, dass, wenn ich mich an künstlichem Streaming beteilige, meine KYC-Daten, einschließlich meines vollständigen Namens, meiner Adresse, meines Personalausweises und anderer persönlicher Informationen, mit den Rechtsabteilungen der DSPs, wie denen von Spotify, Apple Music und anderen, geteilt werden können.",
                            "point6": "<strong>6.</strong> Ich übernehme die volle rechtliche Verantwortung für jegliche Verstöße.",
                            "acknowledgment": "Hiermit erkenne ich die oben genannten Bedingungen für künstliches Streaming an und stimme ihnen zu und übernehme die volle rechtliche Verantwortung für jegliche Verstöße."
                        }
                    },
                    "button": {
                        "cancel": "Abbrechen",
                        "confirm": "Bestätigen und akzeptieren"
                    }
                },
                "finishEditing": {
                    "header": "Sind Sie sicher, dass alle eingegebenen Informationen gültig sind und diese Veröffentlichung vollständig repräsentieren?",
                    "body": {
                        "point1": "Nach dieser Aktion wird Ihre Veröffentlichung überprüft und, wenn die Informationen korrekt sind, erneut an die DSP-Partner verteilt. <strong>HINWEIS, nur METADATEN werden an DSPs gesendet, Inhalte wie BILDER und AUDIO-Dateien können auf diese Weise nicht aktualisiert werden.</strong>",
                        "point2": "Durch Bestätigen und Akzeptieren dieses Formulars akzeptieren und befolgen Sie vollständig die <1>Nutzungsbedingungen</1> und die Bedingungen unseres exklusiven Vertriebsvertrags.",
                        "point3": "Durch Bestätigen und Akzeptieren dieses Formulars akzeptieren und befolgen Sie vollständig die <1>Datenschutzrichtlinie</1>.",
                        "point4": "Durch Bestätigen und Akzeptieren dieses Formulars bestätigen Sie unwiderruflich, dass die eingereichte Veröffentlichung mit zugehörigen Assets, Audiodateien und Metadaten entweder ausschließlich Ihnen gehört oder vollständig an Ihr Label lizenziert ist.",
                        "point5": "Hiermit akzeptieren Sie vollumfänglich, dass Sie allein für irreführende Informationen, unlizenzierte Nutzung, illegale Aktivitäten oder jegliche Art von Streit verantwortlich sind."
                    },
                    "button": {
                        "cancel": "Abbrechen",
                        "confirm": "Bestätigen und akzeptieren"
                    }
                }
            }
        }
    },
    "update": {
        "form": {
            "label": {
                "title": "Track {{trackName}} bearbeiten",
                "mandatoryMetadata": "Pflichtmetadaten",
                "required": "Erforderlich",
                "trackName": "Track-Name",
                "mixName": "Mix-Name",
                "originalmix": "Original Mix",
                "remix": "Dies ist ein Remix oder Mix",
                "vocals": "Gesang",
                "genre": "Genre",
                "subGenre": "Sub-Genre",
                "additionalMetadata": "Zusätzliche Metadaten",
                "copyright": "Urheberrecht ©",
                "copyrightYear": "Urheberrechtsjahr",
                "albumOnly": "Nur Album",
                "explicitContent": "Expliziter Inhalt",
                "isrc": "ISRC",
                "daIsrc": "Dolby Atmos ISRC",
                "generateIsrc": "ISRC generieren",
                "trackLanguageMetadata": "Track-Sprachmetadaten",
                "language": "Sprache",
                "autoDetectLanguage": "Automatisch erkennen (Sprache)",
                "accountingData": "Abrechnungsdaten",
                "labelShare": "Label-Anteil (%)"
            },
            "placeholder": {
                "select": "Auswählen...",
                "labelShare": "z.B. 50"
            },
            "help_text": {
                "trackName": "Titel des Tracks",
                "mixName": "Fügen Sie den Mix-Namen ohne Klammern ein. Einige Tracks werden in mehr als einer Version veröffentlicht. Dieses Feld beschreibt die Version, zum Beispiel 'Bunte Bummler - Aesub (Monika Ross Remix)",
                "vocals": "Hören Sie sich Ihren Track in voller Länge an. Wenn Ihr Track Gesang enthält, wählen Sie bitte die Sprache des Gesangs aus. Wenn Ihr Track keinen Gesang enthält, wählen Sie die Option Instrumental. Überprüfen Sie es doppelt, um sicher zu sein. Wenn diese Eingabe falsch ist, werden einige Stores wie iTunes und Apple Music die Veröffentlichung ablehnen.",
                "publishers": {
                    "publisherName": "<strong>Verlagsname:</strong> Bitte geben Sie den vollständigen Namen des Verlagsunternehmens ein, wenn Sie Verlagsdienste nutzen. Wenn Sie keine offiziellen Verlagsdienste nutzen, geben Sie bitte <strong>Copyright Control</strong> ein/auswählen. Bitte <strong>geben Sie nicht Ihren Labelnamen ein</strong>, wenn es sich nicht um ein registriertes Verlagsunternehmen handelt. Rechtliche Konsequenzen können entstehen.",
                    "authorSongWriterName": "<strong>Autor / Songwriter vollständiger Name:</strong> Bitte geben Sie den <strong>echten Vor- und Nachnamen</strong> der Person ein."
                },
                "contributors": {
                    "contributorsName": "<strong>Namen der Mitwirkenden:</strong> Bitte geben Sie den <strong>echten Vor- und Nachnamen</strong> der Person ein.",
                    "contributorsRoles": "<strong>Rollen der Mitwirkenden:</strong> Mindestens ein Mitwirkender muss als <strong>Komponist</strong> hinzugefügt werden. Wenn Ihr Track aus Gesang besteht, muss mindestens ein Mitwirkender als <strong>Komponist</strong> und ein Mitwirkender als <strong>Texter</strong> hinzugefügt werden."
                },
                "copyright": "Name des Urheberrechtsinhabers",
                "albumOnly": "Gibt an, ob der Track nur als Teil eines Bundle-Releases verkauft wird. Beachten Sie, dass einige Shops diese Anweisung überschreiben könnten",
                "explicitContent": "Bitte markieren Sie dieses Feld, wenn der Track verbotene Texte enthält",
                "isrc": "Der Internationale Standardaufnahmecode, der dem Track zugewiesen ist. Wenn Sie keinen eigenen haben, werden wir einen für Sie generieren",
                "daIsrc": "Der Internationale Standardaufnahmecode, der dem Track zugewiesen ist. Wenn Sie keinen eigenen haben, werden wir einen für Sie generieren",
                "language": "In welcher Sprache ist der Trackname geschrieben? Bitte überprüfen Sie es doppelt, wenn Sie sich nicht sicher sind. Wenn diese Eingabe falsch ist, werden einige Stores wie iTunes und Apple Music die Veröffentlichung ablehnen.",
                "labelShare": "<strong>Tipp:</strong> Der Industriestandard für den <strong>Label-Anteil</strong> beträgt <strong>50%</strong> und <strong>50%</strong> für die <strong>Teilhaber</strong>. Wir raten dringend, den genauen prozentualen Anteil einzutragen, auf den Sie sich mit Ihren Künstlern, Anteilseignern und Partnern geeinigt haben.",
                "costTypes": {
                    "point1": "Geben Sie nur tatsächliche, aufgetretene oder vorab vereinbarte <strong>Kosten</strong> pro Track ein. Wir raten dringend davon ab, falsche Kosten einzugeben.",
                    "point2": "<strong>Kostenarten</strong> können feste oder variable Kosten sein, z.B. <strong>Audio-Mastering, Grafikdesign, Promotion, Marketing</strong> oder andere sinnvolle Ausgaben für den jeweiligen <strong>Track</strong> durch das <strong>Label</strong>."
                }
            },
            "button": {
                "submitTrack": "Track einreichen"
            },
            "message": {
                "successArtistAdded": "Ein neuer Künstler wurde hinzugefügt!",
                "successPublisherAdded": "Ein neuer Verlag wurde hinzugefügt!",
                "successContributorAdded": "Ein neuer Mitwirkender wurde hinzugefügt!",
                "successShareholderAdded": "Ein neuer Anteilseigner wurde hinzugefügt!",
                "successCostTypeAdded": "Eine neue Kostenart wurde hinzugefügt!",
                "errorLabelShareInvalid": "Bitte geben Sie einen gültigen Wert (1-100) ein",
                "errorFormCannotBeSubmitted": "Formular kann nicht eingereicht werden! Bitte füllen Sie alle Felder aus und überprüfen Sie die Fehler!",
                "accountingMetadata": {
                    "title": "WARNUNG",
                    "description": {
                        "point1": "OPTIONALE METADATEN - füllen Sie diesen Teil der Metadaten nur aus, wenn Sie Abrechnungsberichte an Ihre Künstler oder Anteilseigner ausstellen werden!",
                        "point2": "Bitte stellen Sie sicher, dass die in diesem Abschnitt eingereichten Daten vollständig korrekt sind, da sie die Berichte beeinflussen, die Sie an Ihre Künstler und Anteilseigner senden werden.",
                        "point3": "Wir empfehlen dringend, die Eingaben doppelt zu überprüfen, da nach der Einreichung zusätzliche Bearbeitungen und Änderungen aus Gründen der Datenkorrektheit nicht empfohlen werden.",
                        "point4": "Abrechnungsberichte für Ihre Künstler und Anteilseigner haben nur dann eine genaue Wirkung, wenn Sie alle Parameter korrekt und gemäß Ihren Vereinbarungen mit Ihren Künstlern und Anteilseignern einreichen.",
                        "point5": "Kosten können nur einmal hinzugefügt werden und können später aus Gründen der Transparenz und Genauigkeit nicht bearbeitet werden. Stellen Sie sicher, dass Sie alle Track-Kosten beim ersten Versuch genau eingeben."
                    }
                }
            }
        }
    },
    "publishersRow": {
        "form": {
            "label": {
                "publishers": "Verlage",
                "required": "Erforderlich",
                "order": "Reihenfolge",
                "publisherName": "Verlagsname",
                "authorSongWriterName": "Autor / Songwriter vollständiger Name"
            },
            "placeholder": {
                "publisherName": "Verlag auswählen..."
            },
            "button": {
                "addAnother": "Weiteren hinzufügen",
                "createNew": "Neu erstellen?",
                "remove": "Entfernen"
            },
            "message": {
                "publisherRequired": "Bitte wählen Sie einen Verlag",
                "authorSongWriterRequired": "Bitte geben Sie den echten Vor- und Nachnamen der Person ein."
            },
            "modal": {
                "header": "Neuen Verlag hinzufügen",
                "body": {
                    "label": {
                        "name": "Name"
                    },
                    "message": {
                        "nameRequired": "Name ist erforderlich",
                        "publisherAlreadyExists": "Verlag existiert bereits"
                    }
                },
                "button": {
                    "createNew": "Neu erstellen",
                    "cancel": "Abbrechen"
                }
            }
        }
    },
    "contributorsRow": {
        "form": {
            "label": {
                "contributors": "Mitwirkende",
                "required": "Erforderlich",
                "order": "Reihenfolge",
                "contributorName": "Vollständiger Name des Mitwirkenden",
                "contributorRole": "Rolle des Mitwirkenden"
            },
            "placeholder": {
                "contributorName": "Mitwirkenden auswählen..."
            },
            "button": {
                "addAnother": "Weiteren hinzufügen",
                "createNew": "Neu erstellen?",
                "remove": "Entfernen"
            },
            "modal": {
                "header": "Neuen Mitwirkenden hinzufügen",
                "body": {
                    "label": {
                        "name": "Name"
                    },
                    "help_text": {
                        "name": "Bitte geben Sie den vollständigen Vor- und Nachnamen des Songwriters ein. Beispiel: 'Max Mustermann'"
                    },
                    "message": {
                        "nameRequired": "Name ist erforderlich",
                        "nameMustNotBeInUppercase": "Name darf nicht komplett in Großbuchstaben sein",
                        "insertRealName": "Bitte geben Sie den echten Vor- und Nachnamen der Person ein.",
                        "errorContributorAlreadyExists": "Mitwirkender existiert bereits"
                    }
                },
                "button": {
                    "createNew": "Neu erstellen",
                    "cancel": "Abbrechen"
                }
            }
        }
    },
    "shareholdersRow": {
        "form": {
            "label": {
                "order": "Reihenfolge",
                "shareholders": "Anteilseigner",
                "shareholderName": "Name des Anteilseigners",
                "shareholderSplit": "Anteil des Anteilseigners (%)",
                "shareholderRoles": "Rollen des Anteilseigners"
            },
            "placeholder": {
                "shareholderName": "Anteilseigner auswählen...",
                "shareholderSplit": "z.B. 50"
            },
            "message": {
                "shareholderRequired": "Bitte wählen Sie einen Anteilseigner",
                "shareholderSplitRequired": "Bitte geben Sie einen gültigen Wert (1-100) ein",
                "shareholderRolesRequired": "Bitte wählen Sie mindestens eine Rolle",
                "shareSum": "Label-Anteil und Anteilseigner-Anteile sollten zusammen 100% ergeben"
            },
            "button": {
                "addAnother": "Weiteren hinzufügen",
                "createNew": "Neu erstellen?",
                "remove": "Entfernen"
            },
            "modal": {
                "header": "Neuen Anteilseigner hinzufügen",
                "body": {
                    "label": {
                        "name": "Name",
                        "email": "E-Mail"
                    },
                    "help_text": {
                        "name": "Bitte geben Sie den vollständigen Vor- und Nachnamen des Songwriters ein. Beispiel: 'Max Mustermann'"
                    },
                    "message": {
                        "nameRequired": "Name ist erforderlich",
                        "emailRequired": "E-Mail ist erforderlich",
                        "emailInvalid": "E-Mail ist nicht gültig"
                    }
                },
                "button": {
                    "createNew": "Neu erstellen",
                    "cancel": "Abbrechen"
                }
            }
        }
    },
    "costTypesRow": {
        "form": {
            "label": {
                "costTypes": "Kostenarten",
                "order": "Reihenfolge",
                "costType": "Kostenart",
                "cost": "Kosten (€)"
            },
            "placeholder": {
                "costType": "Kostenart auswählen...",
                "cost": "z.B. -7.5"
            },
            "button": {
                "addAnother": "Weiteren hinzufügen",
                "createNew": "Neu erstellen?",
                "remove": "Entfernen"
            },
            "message": {
                "costTypeRequired": "Bitte wählen Sie eine Kostenart",
                "costNotNegative": "Bitte geben Sie einen negativen Wert ein, z.B. -10.0"
            },
            "modal": {
                "header": "Neue Kostenart hinzufügen",
                "body": {
                    "label": {
                        "name": "Name"
                    },
                    "message": {
                        "nameRequired": "Name ist erforderlich",
                        "costTypeAlreadyExists": "Kostenart existiert bereits"
                    },
                    "button": {
                        "createNew": "Neu erstellen",
                        "cancel": "Abbrechen"
                    }
                }
            }
        }
    }
};

export default tracksDE;